import Routes from "./Routes";

// Хлебные крошки. У большинства разделов одна ветка index (label + url,
// parent = null — раздел стал корнем цепочки). У nodes есть ещё show/create —
// их родитель nodes.index, лейбл show берётся из params.name (текущий title
// страницы, см. pageProvider.js).
// Breadcrumbs.For(name, {id, name}) собирает цепочку от корня.
export default class Breadcrumbs {
    static For(routeName, params = {}) {
        const items = [];
        let currentName = routeName;
        while (currentName) {
            const item = Breadcrumbs.getItem(currentName, params);
            if (item === null) break;
            items.unshift(item);
            currentName = item.parent;
        }
        return items;
    }

    static getItem(routeName, params = {}) {
        const url = Routes.parseName(routeName);
        switch (routeName) {
            case 'nodes.index':
                return { label: 'Ноды', url, parent: null };
            case 'nodes.create':
                return { label: 'Новая нода', url, parent: 'nodes.index' };
            case 'nodes.show':
                return { label: params.name || 'Нода', url, parent: 'nodes.index' };
            case 'devices.index':
                return { label: 'Устройства', url, parent: null };
            case 'device-types.index':
                return { label: 'Типы устройств', url, parent: null };
            case 'proxies.index':
                return { label: 'Прокси', url, parent: null };
            case 'proxies.create':
                return { label: 'Новый прокси', url, parent: 'proxies.index' };
            case 'proxies.show':
                return { label: params.name || 'Прокси', url, parent: 'proxies.index' };
            case 'proxy-groups.index':
                return { label: 'Группы прокси', url, parent: null };
            case 'proxy-groups.create':
                return { label: 'Новая группа', url, parent: 'proxy-groups.index' };
            case 'proxy-groups.show':
                return { label: params.name || 'Группа', url, parent: 'proxy-groups.index' };
            case 'users.index':
                return { label: 'Пользователи', url, parent: null };
            case 'files.index':
                return { label: 'APK-файлы', url, parent: null };
            case 'files.create':
                return { label: 'Загрузка APK', url, parent: 'files.index' };
            case 'files.show':
                return { label: params.name || 'Файл', url, parent: 'files.index' };
            case 'benchmarks.index':
                return { label: 'Бенчмарки', url, parent: null };
            case 'benchmarks.show':
                return { label: params.name || 'Замер', url, parent: 'benchmarks.index' };
            case 'screenshots.index':
                return { label: 'Скриншоты', url, parent: null };
            case 'screenshots.show':
                return { label: params.name || 'Снимок', url, parent: 'screenshots.index' };

            default:
                return null;
        }
    }
}
